import { EnumAppointmentReminderStatus } from "@bbj-types/action/appointmentReminder";
import { reminderStatusMapping } from "./mapping";

export interface IReminderStatusIconProps {
  status?: EnumAppointmentReminderStatus;
}

/**
 * Bell icon whose shape and color depend on the appointment reminder status.
 * The color is set here on purpose: the surrounding views force `primary.main` on their icons.
 */
export const ReminderStatusIcon = ({ status }: IReminderStatusIconProps) => {
  const { icon: Icon, color } = reminderStatusMapping[status ?? EnumAppointmentReminderStatus.NOT_SCHEDULED];

  return <Icon sx={{ color, fontSize: 16, flexShrink: 0 }} />;
};
